module.exports = __webpack_public_path__ + "static/media/ic_vod_favorite.a0b594f7.svg";